export class LoanPayoutDetailsModel {
    payoutAmount: number;
    payoutMethod: string;
    payoutReference: string;
}
